import styled from 'styled-components';

import InputSimple, { IPropsInput } from '@r1-frontend/ui-react/components/inputSimple';

export const SearchWrapper = styled.div`
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
`;

export const Input = styled(InputSimple)<IPropsInput>`
    margin-bottom: 0;

    & > input {
        padding-right: 60px;

        &:focus {
            padding-right: 60px;
        }
    }
`;

export const BtnWrap = styled.div`
    position: absolute;
    top: 12px;
    right: 10px;
    bottom: 0;
`;

const Btn = styled.button`
    border: none;
    cursor: pointer;

    &:focus {
        outline: none;
    }
`;

export const ClearBtn = styled(Btn)`
    margin-right: 7px;
    width: 22px;
    height: 22px;
    background-color: transparent;
    opacity: 0.5;

    &:hover {
        opacity: 1;
    }

    &:before, &:after {
        content: '';
        position: absolute;
        top: 0;
        height: 22px;
        width: 1px;
        background-color: #333;
        transform-origin: center;
    }

    &:before {
        transform: rotate(45deg);
    }

    &:after {
        transform: rotate(-45deg);
    }
`;
